import React from "react";
import {useTranslation} from "react-i18next";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";
import styles from "./AnnotationBlock.module.scss";
import window from "../../../lib/WindowExtended";

const AnnotationBlock: React.FC = () => {
  const {t} = useTranslation("checkout");
  const {checkout} = useCheckoutContext();

  const handleChange = (evt: React.ChangeEvent<HTMLTextAreaElement>) => {
    window.annotationTextArea = evt.target.value;
  };

  return (
    <React.Fragment>
      <h2>{t("Anmerkungen")}</h2>
      <p>
        <strong>{t("Bitte beachten Sie:")}</strong>{" "}
        {t("Jede Anmerkung wird manuell von uns geprüft und kann daher zum verzögerten Versand Ihrer Ware führen.")}
      </p>
      <div className={styles.wrapper}>
        <textarea
          onChange={handleChange}
          defaultValue={window.annotationTextArea ?? checkout.customerRemark ?? undefined}
          rows={1}
          placeholder={t("Anmerkungen hinzufügen (optional)")}
        />
      </div>
    </React.Fragment>
  );
};

export default AnnotationBlock;
